import React from 'react';
import { TemplateName } from '../SidebarMenu/styles';
import styled, { keyframes } from 'styled-components';
import { Modal } from 'antd';

export const Container = styled.main`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
`;



export const Wrapper = styled.section`
  height: 100%;
  flex-grow: 1;
  display: flex;
  overflow: hidden;
`;

export const SidebarMenuWrapper = styled.aside`
  height: 100%;
  display: flex;
  position: relative;
  z-index: 100;
  > div {
    background: linear-gradient(137.73deg, rgb(23 2 60) 3.35%, rgb(219, 57, 31) 97.84%) !important;
  }

  &.mailDesign {
    > div {
      background: linear-gradient(
        10deg,
        rgb(49, 145, 151),
        rgb(175, 0, 45) 41.07%,
        rgb(255, 122, 24) 76.05%
      ) !important;
    }
  }

 ${TemplateName} {
   width: calc(100vw - 75px);
   z-index: 101;
   > div {
     display: flex;
     justify-content: center;
     align-items: center;
   }
 }
`;

export const ComplexArtboardWrapper = styled.div`
  width: calc(100% - 950px);
  background-color: ${props => props.blur || 'transparent'};
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: row-reverse;
  .moveable-line {
    will-change: transform;
  }

  &.readOnly {
    overflow: auto;
    ::-webkit-scrollbar {
      display: none;
    }
  }

  &.versions {
    margin-top: 70px;
    background: rgb(245, 248, 250);
  }
`;

export const ToolbarContainer = styled.div`
  width: 100%;
  height: 70px;
`;

export const PagesWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const EditorWrapper = styled.div`
  width: 100%;
  flex-grow: 1;
  flex-shrink: 0;
  margin: 0px auto;
  padding: 24px 0px;
  display: flex;
  padding-left: ${props =>props.dndFlow && '10px'};
  margin-bottom: ${props => (!props.rulerEnabled && "35px")};
  @media only screen and (max-width: 1440px) {
    padding-right: 10px !important;
  }
`;

export const EditingContainer = styled.div`
  width: 100%;
  position: relative;
  margin: auto;
  background-color:${props => props.transparent ? 'transparent' : '#f5f8fa'} ;

  &:hover {
    .dynamicCellSettings{
      .border {
        display: ${props => props.hideBlockSettings ? 'none': 'block'};
      }
      .box-menu {
        opacity: ${props => props.hideBlockSettings ? 0 : 1};
        width: 40px;
        height: 80px;
        padding: 10px;
        box-shadow: 2px 3px 5px rgba(0,0,0,.3);
        .menu {
          left: 0;
          opacity: 1;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: space-around;
        }
        .menu .anticon svg {
          color: #fff;
          opacity: 0.8;
          transform: scale(1.1);
        }
      }
    }
  }

  &.scrollable {
    overflow-y: auto;

    ::-webkit-scrollbar {
      display: none;
    }
  }

  .complex-block-header {
    .moveable-line {
      opacity: 0;
    }

    .moveable-line[data-line-index="3"] {
      opacity: 1 !important;
      cursor: auto;
    }
  }

  .complex-block-footer {
    .moveable-line {
      opacity: 0;
    }

    .moveable-line[data-line-index="0"] {
      opacity: 1 !important;
      cursor: auto;
    }
  }
`;

export const PageContent = styled.div`
  position: relative;
  width: ${props => `${props.width}px`};
  min-height: ${props => `${props.height}px`};
  background-color: ${props => props.backgroundColor || '#fff'};
  filter: ${props => props.isOver ? 'blur(1px)' : 'none'};
  transform: ${props => props.scaling ? `scale(${props.scaling})` : 'scale(1)'};
  font-family: 'Open Sans';
  padding: 0;
  box-sizing: border-box;
  transition: 0.2s all;
  top: ${props => !props.rulerEnabled && "30px"};
  left: ${props => !props.rulerEnabled && "30px"};
  box-shadow: ${props => props.isEmailTemplate ? '' : props.previewModal? '0px 0px 8px 3px rgb(103 110 144 / 20%)' : '0 2px 8px rgba(14,19,24,.07)'};
  transform-origin: 0 0;
  padding-top: 1px; // Added this to suppress browser functionality to move parent along with child on applying margin-top on child
  margin-top: -1px;
  outline: none;
  overflow: hidden;
  .ql-editor {
    ${props => !props.editable && 'pointer-events: none;'};
  }
  * {
    :focus-visible {
      outline: none;
    }
  }
  &.no-space-on-top {
    padding-top: 0;
  }  
`;

export const PageMetaDetails = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => (props.currentDesign !== 'document' || props.isEmailTemplate ? 'flex-end': "space-between" ) };
  position: relative;
  transition: 0.2s all;
  top: ${props => (props.rulerEnabled||props.rulerAdjusted ? '0px' : '25px')};
  left: ${props => props.isEmailTemplate && '30px'};
  padding: ${props=> (props.rulerAdjusted ?'4px' : '4px 4px 4px 30px')};
  font-weight: 600;
  color: ${props=> (props.dndFlow ? 'rgba(242, 243, 245, 0.6)' : 'rgba(14, 19, 24, 0.45)')};
`;

export const PageNumber = styled.div`
  font-size: 16px;  
  margin: ${props => (props.isPreview && '10px 0')};
  color: ${props => (props.isPreview && 'rgba(242, 243, 245, 0.6)')};
`;

export const PageActions = styled.div`
  display: flex;
`;

export const PageActionItem = styled.div`
  position: relative;
  border-radius: 4px;
  border: 1px solid transparent;
  padding: ${props => (props.haveChildren ? '0px' : '0px 6px')};
  margin-left: ${props => (props.noSpace ? '0' : '10px')};
  .anticon svg {
    font-size: ${props => (props.refrencedSection ? '12px' : '18px')} !important;
    color: ${props => ((props.refrencedFlow || props.refrencedSection) ? "rgba(219,57,31)" : props.dndFlow? "rgba(242, 243, 245, 0.6)" : "rgba(14, 19, 24, 0.7)")} !important ;
    stroke: ${props => ((props.refrencedFlow || props.refrencedSection) &&  "rgba(219,57,31) !important")}
  }
  &:hover {
    background-color: rgba(14, 19, 24, 0.07);
    cursor: pointer;
    .anticon {
      color: ${props=> (props.dndFlow? "#ffffff" : "rgba(14, 19, 24, 0.7)")};
      cursor: pointer;
    }
  }
  &:first-child {
    margin-left: 0;
  }
  .ant-checkbox-input{
    opacity:1;
    border: 1px solid #000;
  }

 animation: ${props => ((props.refrencedFlow || props.refrencedSection) && 'times 1s cubic-bezier(.36,.67,.57,.99) infinite')} ;			
			
	@keyframes times {
	0% {
		transform: scale(1.5) translateX(0);
	}
	15% {
		transform: scale(1.5) translateX(5px);
	}
	30% {
		transform: scale(1.5) translateX(-5px);
	}
	45% {
		transform: scale(1.5) translateX(3px);
	}
	60% {
		transform: scale(1.5) translateX(-3px);
	}
	75% {
		transform: scale(1.5) translateX(0);
	}
	100% {
		transform: scale(1.5) translateX(0);
	}
}
`;

export const RulerContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  overflow: hidden;
`;

export const RulerIcon = styled.div`
  position: absolute;
  width: 30px;
  height: 30px;
  left: 0px;
  top: 0px;
`;

export const VerticalLayoutDiv = styled.div`
  .blockLayout {
  }

  .blockLayoutContainer {
    position: relative;
    background-color: 'transparent';
  }

  .emptyLayout {
    background: #00c4cc;
    height: calc(100% - 6em - 50px);
  }

  .empty {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    background: #00c4cc21;
    color: #00c4cc;
    position: relative;
  }

  .emptySpace {
    height: 20px;
    width: 100%;
  }

  ::-webkit-scrollbar {
    width: 0px !important;
    background-color: transparent;
  }
  
`;
export const DragContainter = styled.div`
position: relative;
height: 30px;
> .bottomDrop {  
  position: absolute;  
  width: ${props => (props.maxWidth ?  `${props.maxWidth}px`: "100%" ) };
  height: 30px;
  border-color: #00c4cc;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  &.visible {
    &:before {
        content: '';
        position: absolute;
        bottom: 10px;
        left: -1px;
        background: #00c4cc;
        height: 7px;
        width: calc(100% + 2px);
        color: white;
        z-index: 1;
    }
    &:after {
        content: attr(data-dropContent);
        position: absolute;
        bottom: 3px;
        left: calc(50% - 75px);
        background: #00c4cc;
        height: 22px;
        font-size: 14px;
        width: 150px;
        border-radius: 10px;
        color: white;
        text-align: center;
        z-index: 1;
    }
  }
}
`

export const Content = styled.div`
  position: relative;

  &.isOver {
    outline: 1px solid #00c4cc;
  }

  &.cell {
    height: 100%;
    width: 100%;
    padding: ${props => props.cellPadding ? props.cellPadding : ''};

    &.not-empty {
      display: flex;
      align-items: ${props => props.verticalAlignment === 'before' ? 'flex-start' : props.verticalAlignment === 'after' ? 'flex-end' : 'center'};
      justify-content: ${props => props.horizontalAlignment === 'left' ? 'flex-start' : props.horizontalAlignment === 'right' ? 'flex-end' : 'center'};
    }

    > .selectable {
      height: max-content;
    }
  }

  &.droppable {
      &:before {
        content: '';
        position: absolute;
        bottom: -3px;
        left: 0;
        background: #00c4cc;
        height: 7px;
        width: 100%;
        color: white;
        z-index: 1;
      }
      &:after {
        content: attr(data-dropContent);
        position: absolute;
        bottom: -10px;
        left: calc(50% - 75px);
        background: #00c4cc;
        height: 22px;
        font-size: 14px;
        width: 150px;
        border-radius: 10px;
        color: white;
        text-align: center;
        z-index: 1;
      }
  }

  &.hDroppable {
    &:before {
      content: '';
      position: absolute;
      top: -1px;
      right: -3px;
      background: #00c4cc;
      height: calc(100% + 2px);
      width: 7px;
      color: white;
      z-index: 1;
    }
  }

  > .topDrop {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 25%;
    border-color: #00c4cc;

    &.visible {
      &:before {
          content: '';
          position: absolute;
          top: -3px;
          left: -1px;
          background: #00c4cc;
          height: 7px;
          width: calc(100% + 2px);
          z-index: 1;
      }
      &:after {
          content: attr(data-dropContent);
          position: absolute;
          top: -10px;
          left: calc(50% - 75px);
          background: #00c4cc;
          height: 22px;
          font-size: 14px;
          width: 150px;
          border-radius: 10px;
          color: white;
          text-align: center;
          z-index: 1;
      }
    }
  }
  > .bottomDrop {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 25%;
    border-color: #00c4cc;

    &.visible {
      &:before {
          content: '';
          position: absolute;
          bottom: -3px;
          left: -1px;
          background: #00c4cc;
          height: 7px;
          width: calc(100% + 2px);
          color: white;
          z-index: 1;
      }
      &:after {
          content: attr(data-dropContent);
          position: absolute;
          bottom: -10px;
          left: calc(50% - 75px);
          background: #00c4cc;
          height: 22px;
          font-size: 14px;
          width: 150px;
          border-radius: 10px;
          color: white;
          text-align: center;
          z-index: 1;
      }
    }
  }

  > .leftDrop {
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    border-color: #00c4cc;

    &.visible {
      &:before {
          content: '';
          position: absolute;
          top: -1px;
          left: -3px;
          background: #00c4cc;
          height: calc(100% + 2px);
          width: 7px;
          color: white;
          z-index: 1;
      }
    }
  }
  > .rightDrop {
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    height: 100%;
    border-color: #00c4cc;

    &.visible {
      &:before {
        content: '';
        position: absolute;
        top: -1px;
        right: -3px;
        background: #00c4cc;
        height: calc(100% + 2px);
        width: 7px;
        color: white;
        z-index: 1;
      }
    }
  }
`;

export const QuillContainer = styled.div`
  &.no-cursor p {
    cursor: ${props => props.editable && 'pointer'}  !important;
  }
  .ql-container {
    font-size: inherit;
  }
  .ql-container.ql-snow {
    border: 0;
  }
  .ql-disabled {
    span {
      // pointer-events: none;
    }
  }
  .ql-picker.ql-size .ql-picker-label::before,
  .ql-picker.ql-size .ql-picker-item::before {
    content: attr(data-value) !important;
  }

  .ql-editor.ql-blank::before {
    text-align: center;
    // border-bottom: 1px dashed #00c4cc;
    color: #00c4cc;
    background: transparent;
    font-size: 16px;
    font-style: normal;
    left: 0;
    right: 0;
    font-family: 'Open Sans'; // TODO : Localize the font
  }

  &.selected {
    .ql-editor.ql-blank::before {
      content: '';
    }
  }

  &.subject-editor {
    outline: 1px solid grey;
    padding: 10px !important;
    margin-top: 10px;
  }

  span[assignedVariable] {
    border-radius: 6px;
    background-color: #d3e1eb;
    padding: 1px 2px;
    cursor: pointer;
  }

  .ql-snow {
    strong {
      font-weight: 700;
    }
    em {
      font-style: italic;
    }
    .ql-editor {
      padding: 0px;
      overflow: visible !important;
      &[contenteditable='false'] {
        p {
          user-select: ${props => (props.variablesLayoutEnabled ? 'auto' : 'none')};
          cursor: default;
        }
        ol,
        ul {
          cursor: default;
        }
      }
    }
    .ql-editor {
      p {
        color: black;
        line-height: normal;
        font-size: var(--font-size);
        font-family: var(--font-family);
        .ql-cursor {
          display: contents;
        }
      }
      p * {
        // line-height: normal !important;
        vertical-align: baseline;
        color: inherit;
        // display: inline-block;
      }
      li * {
        // line-height: normal !important;
        vertical-align: bottom;
        color: inherit;
        font-size: inherit;
      }
      p {
        &.ql-indent-1 {
          padding: 0px;
          margin-left: 2.5em;
        }
        &.ql-indent-2 {
          padding: 0px;
          margin-left: 3.5em;
        }
        &.ql-indent-3 {
          padding: 0px;
          margin-left: 4.5em;
        }
        &.ql-indent-4 {
          padding: 0px;
          margin-left: 5.5em;
        }
        &.ql-indent-5 {
          padding: 0px;
          margin-left: 6.5em;
        }
        &.ql-indent-6 {
          padding: 0px;
          margin-left: 7.5em;
        }
        &.ql-indent-7 {
          padding: 0px;
          margin-left: 8.5em;
        }
        &.ql-indent-8 {
          padding: 0px;
          margin-left: 9.5em;
        }
      }
      ol {
        li {
          display: list-item;
          padding: 0px;
          margin-left: 1.5em;
          color: #000;
          font-size: var(--font-size);
          font-family: var(--font-family);
          &:before {
            font-family: inherit;
            vertical-align: middle;
            text-align: center;
            color: var(--color);
            font-size: var(--font-size);
            font-weight: var(--bold);
            font-style: var(--italic);
            background-color: var(--background);
            position: absolute;
          }
          &.ql-indent-1 {
            margin-left: 2.5em;
          }
          &.ql-indent-2 {
            margin-left: 3.5em;
          }
          &.ql-indent-3 {
            margin-left: 4.5em;
          }
          &.ql-indent-4 {
            margin-left: 5.5em;
          }
          &.ql-indent-5 {
            margin-left: 6.5em;
          }
          &.ql-indent-6 {
            margin-left: 7.5em;
          }
          &.ql-indent-7 {
            margin-left: 8.5em;
          }
          &.ql-indent-8 {
            margin-left: 9.5em;
          }
        }
        li {
          counter-reset: none;
          counter-set: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
        }
        li[block-start]:first-of-type{
          counter-set: list-0 calc(var(--block-start));
        }
        li.ql-indent-1 {
            counter-set: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
        }
        li.ql-indent-2 {
            counter-set: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
        }
        li.ql-indent-3 {
            counter-set: list-4 list-5 list-6 list-7 list-8 list-9;
        }
        li.ql-indent-4 {
            counter-set: list-5 list-6 list-7 list-8 list-9;
        }
        li.ql-indent-5 {
            counter-set: list-6 list-7 list-8 list-9;
        }
        li.ql-indent-6 {
            counter-set: list-7 list-8 list-9;
        }
        li.ql-indent-7 {
            counter-set: list-8 list-9;
        }
        li.ql-indent-8 {
            counter-set: list-9;
        }
      }
      ul {
        li {
          display: list-item;
          padding: 0px;
          margin-left: 1.5em;
          color: #000;
          font-size: var(--font-size);
          font-family: var(--font-family);
          &:before {
            font-family: inherit;
            vertical-align: middle;
            text-align: center;
            color: var(--color);
            font-size: var(--font-size);
            font-weight: var(--bold);
            font-style: var(--italic);
            background-color: var(--background);
            position: absolute;
          }
          &.ql-indent-1 {
            margin-left: 2.5em;
          }
          &.ql-indent-2 {
            margin-left: 3.5em;
          }
          &.ql-indent-3 {
            margin-left: 4.5em;
          }
          &.ql-indent-4 {
            margin-left: 5.5em;
          }
          &.ql-indent-5 {
            margin-left: 6.5em;
          }
          &.ql-indent-6 {
            margin-left: 7.5em;
          }
          &.ql-indent-7 {
            margin-left: 8.5em;
          }
          &.ql-indent-8 {
            margin-left: 9.5em;
          }
        }
      }
      ol,
      ul {
        padding: 0px;
      }
    }
    span[data-list] {
      /*visibility: hidden;
      span {
        display: none;
      }*/
      background-color: #d3e1eb;
    }
    /*span[data-list]:before {
      height: 24px;
      width: 65px;
      border-radius: 6px;
      background-color: #d3e1eb;
      padding: 3px 0;
      margin-right: 2px;
      user-select: all;
      content: attr(data-list);
      visibility: visible;
      word-break: break-all;
      line-height: 16px !important;
    }*/
    /*span[data-date] {
      visibility: hidden;
      span {
        display: none;
      }
    }
    span[data-date]:before {
      height: 24px;
      width: 65px;
      border-radius: 6px;
      background-color: #d3e1eb;
      line-height: 16px !important;
      padding: 3px 0;
      margin-right: 2px;
      user-select: all;
      content: '$' '{' attr(data-date) '}';
      visibility: visible;
      word-break: break-all;
    }*/
    span[data-isfillable] {
      visibility: hidden;
      span {
        display: none;
      }
    }
    span[data-isfillable]:before {
      height: 24px;
      width: 65px;
      border-radius: 6px;
      background-color: transparent;
      padding: 3px 0;
      margin-right: 2px;
      user-select: all;
      content: '$''{'attr(data-value)'}';
      visibility: visible;
      word-break: break-all;
    }
    .enable-top-margin {
      border-top-width: 1px;
    }
    .follow-bullets {
      ol, ul {
        li {
          &::before {
            content: attr(data-list-label);
          }
        }
      }
    }
  }
  &.textBox {
    overflow: hidden !important;
    .ql-editor p {
      /* display: inline-block !important; */
      vertical-align: baseline;
    }
    .ql-editor * {
      white-space: nowrap !important;
    }
    .ql-snow, .ql-editor {
      height: 100%;
    }
    span {
      white-space: nowrap !important;
    }
  }
  &.multiline{
    .ql-editor-area, .ql-snow.read-only {
      height: 100%;
      overflow: hidden !important;
      overflow-y: auto !important;
    }
    span{
      white-space: pre-wrap !important;
    }
  }
  .mention {
    border-radius: 6px;
    padding: 3px 0px;
    margin-right: 2px;
    user-select: all;

    span {
      .variable {
        background-color: rgb(211, 225, 235);
      }
      .logic {
        background-color: #DAC7FF !important;
      }
    }
  }
  .mention[data-variable-type="Date"] span {
    background-color: rgb(211, 225, 235);
  }
  .ql-custom-tooltip:not(.ql-hidden) {
    display: flex;
  }
  .ql-custom-tooltip:before {
    content: 'Variable link' !important;
  }
`;

export const DocumentContainer = styled.div`
  position: relative;
  width: calc(100% - 475px);
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  &.preview {
    width: 100%;
    margin: auto;

    ${PageMetaDetails} {
      color: rgba(242, 243, 245, 0.6);
    }

    ${QuillContainer} {
      .mention {
        background-color: transparent;
      }
    }
  }

  &.environment {
    width: 100%;
    margin: auto;

    ${EditingContainer} {
      background-color: transparent;
    }
  }

  &.email-environment {
    margin: 0 auto;
  }

  .moveable-line {
    will-change: transform;
  }
`;

export const ActionButton = styled.div`
  height: 30px;
  border-radius: 10px;
  margin: 5px;
  background: transparent;
  font-size: 15px !important;
  cursor: ${props => props.disabled ? 'not-allowed': 'pointer'};  
  display: flex;
  align-items: center;
`;

export const UndoIcon = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path fill={color} fill-opacity="0.6" d="m6.05 7.25 2.22-2.22A.75.75 0 0 0 7.2 3.97L4.43 6.75c-.69.68-.69 1.8 0 2.48l2.83 2.83A.75.75 0 0 0 8.32 11L6.07 8.75H16a4.25 4.25 0 1 1 0 8.5h-4a.75.75 0 1 0 0 1.5h4a5.75 5.75 0 0 0 0-11.5H6.05z"/>
  </svg>
)

export const RedoIcon = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path fill={color} fill-opacity="0.6" d="m18.054 7.252-2.296-2.296a.75.75 0 0 1 1.06-1.06l2.83 2.828a1.75 1.75 0 0 1 0 2.475l-2.832 2.831a.75.75 0 0 1-1.06-1.06l2.219-2.22H8a4.25 4.25 0 0 0 0 8.5h4a.75.75 0 0 1 0 1.5H8a5.75 5.75 0 0 1 0-11.5h10c.018 0 .036 0 .054.002Z"/>
  </svg>
)

export const SavedIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 3a6 6 0 0 0-5.99 5.661A5.627 5.627 0 0 0 7 19.5v.001h10v-.001a5.625 5.625 0 0 0 2.67-10.506l-1.114 1.114a4.126 4.126 0 0 1-1.806 7.891V18h-9.5v-.002a4.125 4.125 0 0 1-.681-8.21 4.5 4.5 0 0 1 8.549-2.606l1.116-1.117A5.998 5.998 0 0 0 11 3Zm7.631 4.91a.75.75 0 1 0-1.053-1.068L10.67 13.75l-1.93-1.93a.75.75 0 1 0-1.088 1.03l-.001.002 2.444 2.445a.748.748 0 0 0 1.11.037v.001l7.425-7.424Z" fill="#6a7580">
    </path>
  </svg>
)

export const OpenCloudIcon = () => (
  <svg  width="24" height="24" viewBox="0 0 24 24">
<g transform="matrix(1 0 0 1 540 540)" id="4f630dcf-c2b6-4ec5-b8d4-69165acbb8b2">
<rect style={{ stroke: 'none', strokeWidth: 1, strokeDasharray: 'none', strokeLinecap: 'butt', strokeDashoffset: 0, strokeLinejoin: 'miter', strokeMiterlimit: 4, fill: 'rgb(255,255,255)', fillRule: 'nonzero', opacity: 1, visibility: 'hidden' }} vector-effect="non-scaling-stroke" x="-540" y="-540" rx="0" ry="0" width="1080" height="1080"/>
</g>
<g transform="matrix(1 0 0 1 540 540)" id="7ea5da41-c57b-4bac-ac09-8d234d1bb608">
</g>
<g transform="matrix(0.54 0 0 0.53 540 776.55)" id="84dc56d9-e570-429e-88a4-a94701559c44">
<path style={{ stroke: 'rgb(0,0,0)', strokeWidth: 0, strokeDasharray: 'none', strokeLinecap: 'butt', strokeDashoffset: 0, strokeLinejoin: 'miter', strokeMiterlimit: 4, fill: 'rgb(255,255,255)', fillRule: 'nonzero', opacity: 1 }} vector-effect="non-scaling-stroke" transform=" translate(-512, -512)" d="M 512 64 C 264.6 64 64 264.6 64 512 C 64 759.4 264.6 960 512 960 C 759.4 960 960 759.4 960 512 C 960 264.6 759.4 64 512 64 z M 512 884 C 306.6 884 140 717.4 140 512 C 140 423 171.3 341.2 223.5 277.2 L 746.8 800.5 C 682.8 852.7 601 884 512 884 z M 800.5 746.8 L 277.2 223.5 C 341.2 171.3 423 140 512 140 C 717.4 140 884 306.6 884 512 C 884 601 852.7 682.8 800.5 746.8 z" stroke-linecap="round"/>
</g>
<g transform="matrix(1.21 0 0 1.21 540 442.89)">
<path style={{ stroke: 'none', strokeWidth: 1, strokeDasharray: 'none', strokeLinecap: 'butt', strokeDashoffset: 0, strokeLinejoin: 'miter', strokeMiterlimit: 4, fill: 'rgb(255,255,255)', fillRule: 'nonzero', opacity: 1 }} transform=" translate(-512, -462.01)" d="M 811.4 368.9 C 765.6 248 648.9 162 512.2 162 C 375.5000000000001 162 258.8 247.9 213 368.8 C 126.9 391.5 63.5 470.2 64 563.6 C 64.6 668 145.6 752.9 247.6 762 C 252.29999999999998 762.4 256.3 758.7 256.3 754 L 256.3 693.6 C 256.3 689.6 253.3 686.2 249.3 685.7 C 222.3 682.3000000000001 196.8 670.5 177.20000000000002 651.2 C 153.20000000000002 627.7 140 596.1 140 562.6 C 140 534.6 149.1 508.20000000000005 166.2 486.20000000000005 C 182.89999999999998 464.80000000000007 206.39999999999998 449.30000000000007 232.29999999999998 442.50000000000006 L 270.2 432.50000000000006 L 284.09999999999997 395.80000000000007 C 292.7 373.00000000000006 304.7 351.6000000000001 319.79999999999995 332.30000000000007 C 334.69999999999993 313.1000000000001 352.4 296.30000000000007 372.19999999999993 282.30000000000007 C 413.29999999999995 253.40000000000006 461.69999999999993 238.10000000000008 512.1999999999999 238.10000000000008 C 562.6999999999999 238.10000000000008 611.0999999999999 253.4000000000001 652.1999999999999 282.4000000000001 C 672.0999999999999 296.4000000000001 689.6999999999999 313.2000000000001 704.5999999999999 332.4000000000001 C 719.6999999999999 351.7000000000001 731.6999999999999 373.1000000000001 740.3 395.9000000000001 L 754.0999999999999 432.5000000000001 L 791.8999999999999 442.5000000000001 C 846.0999999999999 456.9000000000001 883.9999999999999 506.2000000000001 883.9999999999999 562.5000000000001 C 883.9999999999999 596.1000000000001 870.7999999999998 627.6000000000001 846.7999999999998 651.1000000000001 C 827.2999999999998 670.3000000000002 801.8999999999999 682.2000000000002 774.8999999999999 685.6000000000001 C 770.8999999999999 686.1000000000001 767.9999999999999 689.5000000000001 767.9999999999999 693.5000000000001 L 767.9999999999999 754 C 767.9999999999999 758.7 772.0999999999999 762.4 776.7999999999998 762 C 878.4999999999999 752.8 959.2999999999998 668 959.9999999999998 563.8 C 960.5999999999998 470.4 897.2999999999997 391.69999999999993 811.3999999999997 368.9 z" stroke-linecap="round"/>
</g>

    <rect x="0" y="0" width="100%" height="100%" fill="transparent"></rect>
    <g transform="matrix(1 0 0 1 12 12)" id="4f630dcf-c2b6-4ec5-b8d4-69165acbb8b2">
      <rect style={{ stroke: 'none', strokeWidth: 1, strokeDasharray: 'none', strokeLinecap: 'butt', strokeDashoffset: 0, strokeLinejoin: 'miter', strokeMiterlimit: 4, fill: 'rgb(180,30,30)', fillRule: 'nonzero', opacity: 1, visibility: 'hidden' }} vector-effect="non-scaling-stroke"  x="-12" y="-12" rx="0" ry="0" width="24" height="24" />
    </g>
    <g transform="matrix(Infinity NaN NaN Infinity 0 0)" id="7ea5da41-c57b-4bac-ac09-8d234d1bb608"  >
    </g>
    <g transform="matrix(0.01 0 0 0.01 39.14 38.47)" id="84dc56d9-e570-429e-88a4-a94701559c44"  >
      <path style={{ stroke: 'rgb(0,0,0)', strokeWidth: 0, strokeDasharray: 'none', strokeLinecap: 'butt', strokeDashoffset: 0, strokeLinejoin: 'miter', strokeMiterlimit: 4, fill: 'rgb(255,255,255)', fillRule: 'nonzero', opacity: 1 }} vector-effect="non-scaling-stroke"  transform=" translate(-512, -512)" d="M 512 64 C 264.6 64 64 264.6 64 512 C 64 759.4 264.6 960 512 960 C 759.4 960 960 759.4 960 512 C 960 264.6 759.4 64 512 64 z M 512 884 C 306.6 884 140 717.4 140 512 C 140 423 171.3 341.2 223.5 277.2 L 746.8 800.5 C 682.8 852.7 601 884 512 884 z M 800.5 746.8 L 277.2 223.5 C 341.2 171.3 423 140 512 140 C 717.4 140 884 306.6 884 512 C 884 601 852.7 682.8 800.5 746.8 z" stroke-linecap="round" />
    </g>
    <g transform="matrix(0.02 0 0 0.02 12 12)"  >
      <g style={{}} vector-effect="non-scaling-stroke"   >
		<g transform="matrix(1 0 0 1 0 0)"  >
          <rect style={{ stroke: 'none', strokeWidth: 1, strokeDasharray: 'none', strokeLinecap: 'butt', strokeDashoffset: 0, strokeLinejoin: 'miter', strokeMiterlimit: 4, fill: 'rgb(255,255,255)', fillRule: 'nonzero', opacity: 1, visibility: 'hidden' }} vector-effect="non-scaling-stroke"  x="-540" y="-540" rx="0" ry="0" width="1080" height="1080" />
        </g>
		<g transform="matrix(0.54 0 0 0.53 0 236.55)"  >
          <path style={{ stroke: 'rgb(0,0,0)', strokeWidth: 0, strokeDasharray: 'none', strokeLinecap: 'butt', strokeDashoffset: 0, strokeLinejoin: 'miter', strokeMiterlimit: 4, fill: 'rgb(255,255,255)', fillRule: 'nonzero', opacity: 1 }} vector-effect="non-scaling-stroke"  transform=" translate(-512, -512)" d="M 512 64 C 264.6 64 64 264.6 64 512 C 64 759.4 264.6 960 512 960 C 759.4 960 960 759.4 960 512 C 960 264.6 759.4 64 512 64 z M 512 884 C 306.6 884 140 717.4 140 512 C 140 423 171.3 341.2 223.5 277.2 L 746.8 800.5 C 682.8 852.7 601 884 512 884 z M 800.5 746.8 L 277.2 223.5 C 341.2 171.3 423 140 512 140 C 717.4 140 884 306.6 884 512 C 884 601 852.7 682.8 800.5 746.8 z" stroke-linecap="round" />
        </g>
		<g transform="matrix(1.21 0 0 1.21 0 -97.1)"  >
          <path style={{ stroke: 'none', strokeWidth: 1, strokeDasharray: 'none', strokeLinecap: 'butt', strokeDashoffset: 0, strokeLinejoin: 'miter', strokeMiterlimit: 4, fill: 'rgb(255,255,255)', fillRule: 'nonzero', opacity: 1 }} vector-effect="non-scaling-stroke"  transform=" translate(-512, -462.01)" d="M 811.4 368.9 C 765.6 248 648.9 162 512.2 162 C 375.5000000000001 162 258.8 247.9 213 368.8 C 126.9 391.5 63.5 470.2 64 563.6 C 64.6 668 145.6 752.9 247.6 762 C 252.29999999999998 762.4 256.3 758.7 256.3 754 L 256.3 693.6 C 256.3 689.6 253.3 686.2 249.3 685.7 C 222.3 682.3000000000001 196.8 670.5 177.20000000000002 651.2 C 153.20000000000002 627.7 140 596.1 140 562.6 C 140 534.6 149.1 508.20000000000005 166.2 486.20000000000005 C 182.89999999999998 464.80000000000007 206.39999999999998 449.30000000000007 232.29999999999998 442.50000000000006 L 270.2 432.50000000000006 L 284.09999999999997 395.80000000000007 C 292.7 373.00000000000006 304.7 351.6000000000001 319.79999999999995 332.30000000000007 C 334.69999999999993 313.1000000000001 352.4 296.30000000000007 372.19999999999993 282.30000000000007 C 413.29999999999995 253.40000000000006 461.69999999999993 238.10000000000008 512.1999999999999 238.10000000000008 C 562.6999999999999 238.10000000000008 611.0999999999999 253.4000000000001 652.1999999999999 282.4000000000001 C 672.0999999999999 296.4000000000001 689.6999999999999 313.2000000000001 704.5999999999999 332.4000000000001 C 719.6999999999999 351.7000000000001 731.6999999999999 373.1000000000001 740.3 395.9000000000001 L 754.0999999999999 432.5000000000001 L 791.8999999999999 442.5000000000001 C 846.0999999999999 456.9000000000001 883.9999999999999 506.2000000000001 883.9999999999999 562.5000000000001 C 883.9999999999999 596.1000000000001 870.7999999999998 627.6000000000001 846.7999999999998 651.1000000000001 C 827.2999999999998 670.3000000000002 801.8999999999999 682.2000000000002 774.8999999999999 685.6000000000001 C 770.8999999999999 686.1000000000001 767.9999999999999 689.5000000000001 767.9999999999999 693.5000000000001 L 767.9999999999999 754 C 767.9999999999999 758.7 772.0999999999999 762.4 776.7999999999998 762 C 878.4999999999999 752.8 959.2999999999998 668 959.9999999999998 563.8 C 960.5999999999998 470.4 897.2999999999997 391.69999999999993 811.3999999999997 368.9 z" stroke-linecap="round" />
        </g>
      </g>
    </g>
  </svg>
)

export const LayoutContainer = styled.div`
  width: 350px;
  height: calc(100% - 70px);
  margin-top: 10px;
  background: #fff;
  box-shadow: 0 16px 38px -12px rgb(0 0 0 / 56%), 0 4px 25px 0 rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(0 0 0 / 20%);
  overflow-y: auto;
  z-index: 99;
  cursor: ${({isInteractiveDesign}) => isInteractiveDesign && 'not-allowed'};
  * {
    pointer-events: ${({isInteractiveDesign}) => isInteractiveDesign && 'none'};
  }

  .title {
    font-weight: bold;
    color: #0e1318;
    padding: 0 30px;
    font-size: 16px;
    height: 60px;
    display: flex;
    align-items: center;
    box-shadow: 0 1px 0 rgba(14, 19, 24, 0.15);
    justify-content: ${props => props.isPageSettings && 'space-between'};
  }

  .size-container {
    display: flex;
    justify-content: space-between;
    width: 40%;
    .ant-select-selection--single {
      height: 30px;
      display: flex;
      align-items: center;
      width: 70px;
    }
  }

  .properties-container {
    padding: 25px 30px;
    display: flex;
    flex-direction: column;
  }

  .grid {
    display: flex;
    flex-wrap: wrap;
  }

  .input-container {
    display: flex;
    flex-direction: column;
    margin: 0px 25px 20px 0px;
    .ant-input-number {
      width: 125px;
      &:hover {
        border-color: #313233 !important;
      }
    }
    .ant-input-number-input {
      font-size: 14px;
      font-weight: 600;
    }
    &:last-child {
      margin-right: 0px;
    }
  }
`;

export const PageLayoutInputLabel = styled.label`
  color: #3c4043;
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  .metrics {
    margin-left: 5px;
    font-size: 10px;
  }
  .anticon {
    font-size: 16px;
    margin-right: 10px;
  }
`;

export const BackgroundColorBox = styled.div`
  width: 75px;
  height: 50px;
  border: 2px solid #eee;
  position: relative;
  pointer-events: ${props => props.disabled ? 'none': 'all'};
`;

export const PageBackgroundPicker = styled.div`
  position: absolute;
  top: 48px;
  z-index: 10000;
`;

export const SettingsCloseButton = styled.div`
  position: absolute;
  visibility: hidden;
  width: 40px;
  height: 40px;
  border-top-right-radius: calc(19px);
  border-bottom-right-radius: calc(19px);
  background-color: #ffffff;
  padding-right: 5px;
  top: 100px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 1px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  right: -40px;
  z-index: 100;
  .layoutbtn-container {
    width: 100%;
    height: 100%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &:hover {
    cursor: pointer;
  }
  animation: 0.5s ease-in-out;
`;

export const CreativeBlockContainer = styled.div`
  position: relative;
  z-index: ${props => props.currentBlock ? 2 : 0};
  overflow: ${props => props.staticTableBlock ? 'visible' : 'hidden'};
  padding: ${props => props.padding ? `${props.padding.top}px ${props.padding.right}px ${props.padding.bottom}px ${props.padding.left}px` : '0'};

  &.empty {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #00c4cc;
    background: transparent;
    position: relative;
  }

  &.block-not-fit {
    border: dashed #FF0000;
  }

  .tag {
    background: #FF0000;
    color: #fff;
    font-size: 12px;
    min-width: 390px;
    width: fit-content;
    height: 25px;
    display: flex;
    align-items: center;
    font-weight: 600;
    position: absolute;
    z-index: 1;
    padding: 0 10px 0 10px;
    border-radius: 0 0 15px 0;
    top:0;
    left:0;
    svg {
      margin-left: 10px;
      font-size: 12px;
    }
  }

  svg {
    display: block;
  }

  .selectable {
    transform-origin: 0 0;
  }
  .highlight::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    outline: 2px solid #00c4cc;
  }
  .accessibility-icon {
    position: absolute;
    top: -45px;
    left: calc(50% - 18px);
  }
`;

export const RelativeDiv = styled.div`
  left: ${props => `${props.leftMargin}px`};
  right: ${props => `${props.rightMargin}px`};
  top: ${props => `${props.topMargin}px`};
  bottom: ${props => `${props.bottomMargin}px`};
`;

export const MarginalDiv = styled.div`
  margin-left: ${props => `${props.leftMargin}px`};
  margin-right: ${props => `${props.rightMargin}px`};
  margin-top: ${props => `${props.topMargin}px`};
  margin-bottom: ${props => `${props.bottomMargin}px`};
`;

export const AddNewFlowButton = styled.div`
  width: 100%;
  max-width: 700px;
  margin: auto;
  font-size: 14px;
  padding: 6px;
  color: rgba(14, 19, 24, 0.6);
  font-weight: 600;
  border: ${props => props.document && "2px solid rgba(14, 19, 24, 0.07) "};
  border-radius: 4px;
  margin: 15px auto 30px;
  margin-bottom: ${props => props.isInsertsAvailable ? '' : '100px'};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
    border-color: rgba(14, 19, 24, 0.25);
    color: rgba(14, 19, 24, 0.7);
  }
  .anticon {
    font-size: 12px;
    margin-right: 10px;
  }
`;

export const ImageView = styled.img`
  width: 100%;
  height: 100%;
`;

export const ComboBoxGrp = styled.div`
  width: 100% !important;
  height: 100% !important;
  .ant-select {
    display: flex;
    width: 100% !important;
    height: 100% !important;
  }
  .ant-select-selection {
    height: 100% !important;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: transparent !important;
    border: 1px solid transparent !important;
  }
  .ant-select-selection__rendered {
    height: ${props => props.isComboboxGroup ? '' : '100% !important'};
    display: flex !important;
    margin-left: 6px;
    overflow: hidden;
    line-height: 24px;
  }
  .ant-select-arrow {
    height: 100%;
    right: -0.8px;
    top: 0;
    margin-top: 0;
    .ant-select-arrow-icon {
      right: 0px;
      position: absolute;
      background: #dcdeea;
      border: 1.5px solid #94959e;
      color: #94959e;
      height: 100%;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 10px !important;
    }
  }
  .ant-select-selection-selected-value {
    color: ${props => props.elemStyles.color};
    height: ${props => props.elemStyles.height.toString().includes('px') ? props.elemStyles.height : props.staticTableBlock ? `${props.elemStyles.height}%` : `${props.elemStyles.height}px`};
    width: ${props => props.elemStyles.width.toString().includes('px') ? props.elemStyles.width : props.staticTableBlock ? `${props.elemStyles.width}%` : `${props.elemStyles.width}px`};
    font-size: ${props => `${props.elemStyles.fontSize}px`};
    overflow: ${props => props.staticTableBlock ? 'initial' : 'hidden'};
  }
  .ant-select-disabled .ant-select-selection {
    background: transparent;
    cursor: auto;
  }
  .comBox-values {
    display: none;
  }
  .showValues {
    display: block;
    margin-top: 1px;
    background: ${props => props.elemStyles.background};
    font-size: ${props =>  `${props.elemStyles.size}px`};
    max-height: 200px;
    overflow: hidden;
    overflow-y: auto;
    p {
      font-size: ${props => `${props.elemStyles.size}px`} !important;
      padding: 5px !important;
      cursor: pointer;
      &:hover {
        background: #ebe7e7;
      }
    }
    .selected {
      background: #74b9d7 !important;
    }
  }
  .ant-select-selection__placeholder {
    color: #5f5f5f !important;
    position: relative !important;
  }
`;

export const ComboOption = styled.div`
  color: ${props => `${props.elemStyles.color} !important`};
  font-size: ${props =>  `${props.elemStyles.fontSize}px`};
  font-family: ${props => props.elemStyles.fontFamily};
  line-height: inherit;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: ${props => props.elemStyles.height.toString().includes('px') ? props.elemStyles.height : props.staticTableBlock ? `${props.elemStyles.height}%` : `${props.elemStyles.height}px`};
  width: ${props => props.elemStyles.width.toString().includes('px') ? props.elemStyles.width : props.staticTableBlock ? `${props.elemStyles.width}%` : `${props.elemStyles.width}px`};
`;

export const FontSizeValue = styled.span`
  width: 40px;
  height: 32px;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  border-color: #d9d9d9;
  color: #fff;
  border-style: solid;
  border-top-width: 1px;
  border-bottom-width: 1px;
  white-space: nowrap;

  br {
    display: none;
  }

  * {
    display: inline;
    white-space: nowrap;
  }

  &:focus {
    overflow-x: auto;
  }
`;

export const DynamicCellSettings = styled.div`

  .border {
    position: absolute;
    top: ${props => props.absoluteStyles?.top};
    left: ${props => props.absoluteStyles?.left};
    display: none;
    z-index: 1000;

    .outline-top {
      position: absolute;
      width: ${props => props.absoluteStyles?.width};
      height: 1px;
      top: 0;
      left: 0;
      border-top: 1px dashed #00c4cc;
    }

    .outline-right {
      position: absolute;
      width: 1px;
      height: ${props => props.absoluteStyles?.height};
      top: 0;
      left: ${props => props.absoluteStyles?.width};
      border-left: 1px dashed #00c4cc;
    }

    .outline-bottom {
      position: absolute;
      width: ${props => props.absoluteStyles?.width};
      height: 1px;
      top: ${props => props.absoluteStyles?.height};
      left: 0;
      border-top: 1px dashed #00c4cc;
    }

    .outline-left {
      position: absolute;
      width: 1px;
      height: ${props => props.absoluteStyles?.height};
      top: 0;
      left: 0;
      border-left: 1px dashed #00c4cc;
    }
  }

  .box-menu {
    position: absolute;
    top: ${props => props.elmstyle.top && props.elmstyle.top };
    right: ${props => props.elmstyle.right && props.elmstyle.right };
    display: ${props => props.elmstyle.right ? 'flex' : 'none'};
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    opacity: ${props => props.isVisible ? 1 : 0};
    padding: 10px;
    background: rgb(37,41,45) !important;
    width: ${props => props.isVisible ? '40px' : 0};
    height: ${props => props.isVisible ? '80px' : 0};
    box-shadow: ${props => props.isVisible ? '2px 3px 5px rgba(0,0,0,.3)' : 'transparent'};
    border-radius: 15px;
    z-index: 10001;
    .editable {
      background: red;
    }
    .menu {
      height: ${props => props.isVisible && '100%'};
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-around;
    }
    .menu .anticon svg {
      font-size: 14px;
      stroke-width: 20px;
      stroke: #fff;
      color: #fff;
      opacity: 0.8;
      transform: scale(1.1);
    }
  }
`;

export const BlockHighlighter= styled.div`
  .border {
    position: absolute;
    top: ${props => props.blockStyle?.top};
    left: ${props => props.blockStyle?.left};
    visibility: ${props => props.blockStyle?.isVisible || 'hidden'};
    z-index: 1;

    .tag {
      background: #00c4cc;
      color: #fff;
      font-size: 11px;
      text-transform: uppercase;
      letter-spacing: 1px;
      min-width: 200px;
      width: fit-content;
      padding: 5px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      ::before {
        content:"• ";
        margin-right: 5px;
        font-size: 18px;
      }
    }

    .outline-top {
      position: absolute;
      width: ${props => props.blockStyle?.width};
      height: 1px;
      top: 0;
      left: 0;
      border-top: 2px solid #00c4cc;
    }

    .outline-right {
      position: absolute;
      width: 1px;
      height: ${props => props.blockStyle?.height};
      top: 0;
      left: ${props => props.blockStyle?.width};
      border-left: 2px solid #00c4cc;
    }

    .outline-bottom {
      position: absolute;
      width: ${props => props.blockStyle?.width};
      height: 1px;
      top: ${props => props.blockStyle?.height};
      left: 0;
      border-top: 2px solid #00c4cc;
    }

    .outline-left {
      position: absolute;
      width: 1px;
      height: ${props => props.blockStyle?.height};
      top: 0;
      left: 0;
      border-left: 2px solid #00c4cc;
    }
  }
`;


const slideIn = keyframes`
  0% {
    left: calc(50% - 10px);
    width: 20px;
    height: 20px;
  }
  100% {
    left: calc(50% - 92.5px);
    height: 40px;
    width: 185px;
  }
`;

const showIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const ColumnResizer = styled.div`
  position: absolute;
  top: ${props => `${props.top || 0}px`};
  left: ${props => `calc(${props.leftStart}${props.isStatic ? 'px' : '%'} - ${-props.left + 2}px)`};
  width: ${props => props.horizontal ? '100%' : props.width || '4px'};
  height: ${props => props.horizontal ? '4px' : props.height || '100%'};
  background-color: transparent;

  .headerOptions {
      position: absolute;
      top: -10px;
      left: calc(50% - 10px);
      opacity: 0;
      z-index: 3;
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      .drawOptions {
        opacity: 0;
        width: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        pointer-events: none;

        input {
          width: 0;
        }
      }

      &.selected {
        opacity: 1;
        width: 185px;
        height: 40px;
        left: calc(50% - 92.5px);
        justify-content: center;
        animation: ${props => slideIn} 0.5s ease-in-out !important;
        z-index: 2;

        .anticon.anticon-ellipsis {
          display: none;
        }
        .drawOptions {
          opacity: 1;
          width: 100%;
          pointer-events: all;

          input {
            width: 150px;
            padding: 0;
            height: 28px;
            transition: width 0.5s ease-in-out;
          }

          .ant-select-selection {
            height: 28px;
          }

          .ant-select-selection__rendered {
            line-height: 26px;
          }

          &.expand {
            width: auto;
            height: 100%;
            background: white;
            border-radius: 4px;
            padding: 6px;
          }
        }
      }
    }

  .addColumnOptions {
    position: absolute;
    // opacity: 0;
    top: -30px;
    z-index: 1;
    opacity: 0;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    &.left {
      left: 0;
    }
    &.right {
      right: 0;
    }

    &:hover {
      opacity: 1;
    }
  }

  &:hover {
    background-color: ${props => props.selected ? 'transparent' : '#00c4cc20'};
    cursor: ${props => props.isResizable === false ? 'pointer' : 'col-resize'};
      .headerOptions {
        opacity: 1;
        animation: ${props => showIn} 0.5s ease-in-out;
      }

    .addColumnOptions {
      opacity: 1;
    }
  }
`;

export const CustomTableHeader = styled.th`
  width: ${props => `${props.groupHeader ? 'fit-content' : props.customStyle?.width}%`};
  border: ${props => `1px solid ${props.customStyle?.border?.borderColor || 'black'}`};
  border-top-width: ${props => props.customStyle?.border?.top ? '1px' : 0};
  border-right-width: ${props => props.customStyle?.border?.right ? '1px' : 0};
  border-bottom-width: ${props => props.customStyle?.border?.bottom ? '1px' : 0};
  border-left-width: ${props => props.customStyle?.border?.left ? '1px' : 0};
  background-color: ${props => props.customStyle?.backgroundColor};
  padding: 0;

  .groupHeader {
    cursor: pointer;
    &:hover {
      &:after {
        content: '';
        width: 100%;
        height: 100%;
        display: block;
        position: absolute;
        top: 0;
        background: #00c4cc20;
        pointer-events: none;
      }
    }
  }
`;

export const CustomTableData = styled.td`
  border: ${props => `1px solid ${props.customStyle?.border?.borderColor || 'black'}`};
  border-top-width: ${props => props.customStyle?.border?.top ? '1px' : 0};
  border-right-width: ${props => props.customStyle?.border?.right ? '1px' : 0};
  border-bottom-width: ${props => props.customStyle?.border?.bottom ? '1px' : 0};
  border-left-width: ${props => props.customStyle?.border?.left ? '1px' : 0};
  background-color: ${props => props.customStyle?.backgroundColor};
`;

export const StaticTable = styled.table`
  position: relative;
  table-layout: fixed;
  width: 100%;
  overflow: visible;
  // overflow: ${props => props.staticTableBlock ? 'visible' : 'hidden'};
  .row-resizer {
    cursor: row-resize;
  }

  .col-resizer {
    cursor: col-resize;
    z-index: 100;
  }

  .hoverButton {
    // background: #e1ffff;
    background: white;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 4px;
    cursor: pointer;

     i {
       color: #333;
     }
  }

  &.block-table {
    > tr {
      position: relative;

      .resizer {
        cursor: auto;
        top: calc(100% - 3px);
      }
    }
  }
`;

export const DynamicTable = styled.table`
  position: relative;
  table-layout: fixed;
  width: 100%;

  border: ${props => `1px solid ${props.border?.borderColor || 'black'}`};
  border-top-width: ${props => props.border?.top ? '1px' : 0};
  border-right-width: ${props => props.border?.right ? '1px' : 0};
  border-bottom-width: ${props => props.border?.bottom ? '1px' : 0};
  border-left-width: ${props => props.border?.left ? '1px' : 0};

  th {
    vertical-align: baseline;
  }

  td {
    vertical-align: baseline;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .hoverButton {
    // background: #e1ffff;
    background: white;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 4px;
    cursor: pointer;

     i {
       color: #333;
     }
  }

  .tableHeader {
    position: relative;

  .headerOptions {
      position: absolute;
      top: -10px;
      left: calc(50% - 10px);
      opacity: 0;
      z-index: 3;
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      .drawOptions {
        opacity: 0;
        width: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        pointer-events: none;

        input {
          width: 0;
        }
      }

      &.selected {
        opacity: 1;
        width: 185px;
        height: 40px;
        left: calc(50% - 92.5px);
        justify-content: center;
        animation: ${props => slideIn} 0.5s ease-in-out !important;
        z-index: 2;

        .anticon.anticon-ellipsis {
          display: none;
        }
        .drawOptions {
          opacity: 1;
          width: 100%;
          pointer-events: all;

          input {
            width: 150px;
            padding: 0;
            height: 28px;
            transition: width 0.5s ease-in-out;
          }
        }
      }
    }

    &:hover {
      .headerOptions {
        opacity: 1;
        animation: ${props => showIn} 0.5s ease-in-out;
      }
    }

    .addColumnOptions {
      position: absolute;
      // opacity: 0;
      top: -30px;
      z-index: 1;
      opacity: 0;
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      &.left {
        left: -10px;
      }
      &.right {
        right: -10px;
      }

      &:hover {
        opacity: 1;
      }
    }
  }
`;

export const ColumnDragLayer = styled.div`
  position: absolute;
  pointer-events: none;
  top: 0;
  height: 100%;
  background-color: #00c4cc;
  opacity: 0.1;
  z-index: 2;
`;

export const Highlight = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${props => props.background};
  // z-index: 0;
  pointer-events: none;
`;

export const ColorPickerContainer = styled.div`
  position: absolute;
  z-index: 100;
  top: 30px;
  right: 20px;
`;

export const EmptyMappingNote = styled.p`
  color: white;
  font-weight: bold;
  margin: 0 20px;
  font-size: 14px;
`;

export const VersionView = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(2, 2, 2, 0.82);
  backdrop-filter: blur(10px);
  z-index: 1000000;
  display: flex;
  flex-direction: row;

  .menu {
    max-width: 400px;
    min-width: 400px;
  }
`;

export const PublishList = styled.ul`
  margin: 60px 0 0 75px;
  border-bottom: 1px solid white;
  li {
    min-height: 60px;
    width: 180px;
    align-items: center;
    justify-content: flex-start;
    display: flex;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
    transition: transform 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93) 0s;
    i {
      margin-right: 10px;
      font-size: 20px;
      color: #fff;
    }
    .column {
      display: flex;
      flex-direction: column;
    }
  }
  .note-text {
    font-size: 12px;
    color: hsla(0, 0%, 100%, 65%);
  }
  .active {
    color: #fff;
    transition: all 0.25s;
  }
`;

export const ListView = styled.li`
    color: ${props => (props.activeVersion ? '#fff' : 'hsla(0,0%,100%,65%)')};
    // font-weight: ${props => props.activeVersion && '700'};
    font-weight: 600;
    font-size: 15px !important;
    transform: ${props => props.activeVersion && 'scale(1.05)'};
    transition: all .25s;
    @media only screen and (min-width: 1460px) {
      font-size: 17px !important;
    }
    i {
      color: ${props => (props.activeVersion ? '#fff' : 'hsla(0,0%,100%,65%)')};
    }
`;

export const VersionMenu = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 70px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 30px;
  z-index: 1;

  button {
    margin: 0 10px;
    background: #b1272c;
    color: #fff;
    border: 2px solid #b1272c;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    &:hover {
      color: #b1272c;
      background-color: #b1272c !important;
      border-color: #b1272c;
      color: #fff;
    }
    &:focus {
      color: #fff;
      background-color: #b1272c;
      border-color: #b1272c;
    }
  }
  i.anticon.anticon-close {
    margin: 0px 10px;
    color: #000;
    font-size: 15px;
    background-color: #fff;
    padding: 8px;
    border-radius: 50%;
    cursor: pointer;
  }
  svg.svg-icon {
    width: 20px !important;
    height: 20px !important;
  }
`;

export const MenuListWrapper = styled.ul`
  width: 100%;
  min-width: 220px;
  list-style: none;
  padding: 8px 0;
  background-color: #fff;
  border: 1px solid rgba(14, 19, 24, 0.07);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(14, 19, 24, 0.15);
  .list-break {
    border: none;
    border-bottom: 1px solid rgba(64,87,109,.07);
  }
`;

export const MenuListItem = styled.li`
  pointer-events: ${({disabled}) => disabled ? "none" : "auto"};
  opacity: ${({disabled}) => disabled ? ".5" : "1"};
  color: #0e1318;
  font-size: 14px;
  font-weight: 500;
  padding: 12px;
  display: flex;
  align-items: center;
  &:hover {
    background-color: rgba(14,19,24,.07);
    cursor: pointer;
  }
  .anticon {
    font-size: 22px;
    margin-right: 10px;
    color: rgb(14 19 24 / 0.7);
  }
`;

export const EndContainer = styled.span`
  display: flex;
  min-width: auto;
  justify-content: end;
  align-items: center;
  column-gap: 8px;
  .small-switch {
    &.switch1 {
      width: 40px;
    }
    &.switch2 {
      width: 80px;
      > button {
        margin-right: 20px;
      }
    }
    .switch-name {
      color: #fff;
      font-size: 14px;
    }
  }
  /* ----------- Non-Retina Screens ----------- */
  @media screen and (max-device-width: 1024px) {
    // min-width: ${({ currentBlock }) => (!currentBlock ? '41%' : '21%')};
    transform: scale(0.55);
    transform-origin: right;
  }
  @media screen and (min-device-width: 1025px) and (max-device-width: 1120px) {
    // min-width: ${({ currentBlock }) => (!currentBlock ? '41%' : '20%')};
    transform: scale(0.6);
    transform-origin: right;
  }
  @media screen and (min-device-width: 1121px) and (max-device-width: 1280px) {
    // min-width: ${({ currentBlock }) => (!currentBlock ? '41%' : '20%')};
    transform: scale(0.7);
    transform-origin: right;
  }
  @media screen and (min-device-width: 1281px) and (max-device-width: 1395px) {
    // min-width: ${({ currentBlock }) => (!currentBlock ? '32%' : '18%')};
    transform: scale(0.8);
    transform-origin: right;
  }
  @media screen and (min-device-width: 1367px) and (max-device-width: 1980) and (-webkit-min-device-pixel-ratio: 1) {
    // min-width: ${({ currentBlock }) => (!currentBlock ? '32%' : '15%')};
  }
`;

export const PreviewEndContainer = styled.div `
  display: flex;
  justify-content: ${({ isPreview }) => isPreview? 'space-evenly !important' : 'center'} ;
  margin: 0px 10px;
  min-width: ${({ isPreview }) => isPreview?  'fit-content' : 'auto'};
  column-gap: ${({ isPreview }) => isPreview && '10px'};
  .previewPageNumber{
    z-index: 12;
    pointer-events: auto;
  } 
  .ant-btn.exit_preview{
    z-index: 12;
    pointer-events: auto;
  }
`;

export const PreviewPageNumberInput = styled.div`
  display: flex;
  .ant-typography{
    color: white;
    display: flex;
    align-items: center;
    font-weight: 600;
    margin: 0px 10px;
  }
  .ant-input-number{
    width: 35px;
    height: 25px;
  }
  .ant-input-number-input{
    text-align: center;
    padding: 0px;
    height: 25px;
  }
  .ant-input-number .ant-input-number-handler-wrap {
    display: none;
  }
`;

export const AutoSaveBlockerModal = styled(Modal)`
  p {
    font-family: 'Open Sans', sans-serif;
    color: #000;
  }
  a {
    text-underline-position: under;
  }
  .footer {
    display: flex;
    column-gap: 24px;
    width: fit-content;
    margin: auto;
    flex-wrap: wrap;
  }
  .ant-modal-footer {
    padding-bottom: 34px !important;
    .ant-btn:first-child {
      background: #f3f3f3 !important;
      color: #333 !important;
    }
    .ant-btn:last-child {
      color: #fff !important;
      background: #000 !important;
    }
  }
`;

export const CellStyleButtons = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  span {
    color: #fff;
  }
  .border-options {
    color: #fff;
    display: flex;
    align-items: center;
    gap: 6px;
  }
`;

export const DownloadButton = styled.div`
    outline: 0;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    border-radius: 50px;
    background-color: #ffeb3b;
    border: #ffeb3b;
    color: #000;
    min-width: 150px;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    height: 32px;
    padding: 0 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: ${props => props.disabled ? 'none' : 'all'};
    
    .ant-dropdown-menu {
      width: 300px;
      }
      .ant-dropdown-menu-item, .ant-dropdown-menu-submenu-title {
        font-weight: bold;
        font-size: 10px;
        padding: 6px 12px;
        margin: 1px 0px;
        text-wrap: wrap;
        
        &:hover {
          background: #8C52FF !important;
          color: white;
          }
          }
          .ant-dropdown-menu-item-group-title {
            font-size: 9px;
            }
            
            &.transaction-btn {
              margin: 0 10px;
              min-width: 190px;
              background-color: #6f55ff;
              border: #6f55ff;
              color: #ffffff;
              cursor: ${props => props.interactiveEditable ? 'pointer' : 'not-allowed'};
    }
    &.loading {
        width: 230px;
    }
`;

export const ComplexPreviewTabsContainer = styled.div`
 cursor: ${({ disabled }) => disabled ? 'not-allowed' : ''};
  * {
    pointer-events: ${({ disabled }) => disabled ? 'none' : '' };
  }
    transition: all 0.6s ease;
  overflow-y: auto !important;
    .card-design{
    width: 99%;
    background-color: #FFFFFF12;
    color: white;
    border-radius: 5px;
    margin-top: 16px;
    cursor: pointer;
    border-bottom: 0px;
  }
    &::-webkit-scrollbar {
    display: none;
  }
  .card-design .ant-collapse-header {
  color: white !important;
 }
  .card-design .ant-collapse-item {
  border-bottom: none;
  }
  .card-design .ant-collapse-content-box{
  background-color: #FFFFFF12 !important;
  }
  .card-design .anticon svg {
    height: 22px;
    width: 22px;
}
  .accordion-header{
   display: flex
    justify-content: space-between
   alignItems: center 
  }
  .ant-card-body {
    padding: 16px;
    zoom: 1;
}
  .card-heading{
  display: flex;
  flex-direction: row;
  gap: 8px;
  color: white;
  margin-bottom: 5px;
  }
 .non-accessibleList{
  display: flex;
  color: white;
  flex-direction: row;
  justify-content: space-between;
  width: 100%
  margin-bottom: 15px; 
  margin-top: 15px; 
  padding: 10px;
  border: 3px solid;
  border-color: darkred;
  border-radius: 5px;
  }
  .card-view{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  }
.issues-card{
    border-radius: 8px;
    background-color: #5c6269;
    padding: 4px 12px;
    font-size: 14px;
    font-weight: 500;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 70px;
    text-align: center;
}
.success-card { 
  padding: 40px 12px;
  text-align: center;
  color: #ffffff;
}

.success-icon {
  font-size: 40px;
  margin-bottom: 16px;
}

.success-title {
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #ffffff;
}

.success-message {
  font-size: 16px;
  color: #cfd3dc;
  margin-bottom: 24px;
  line-height: 1.6;
}

.back-button {
    background: #917bf7;
    color: #fff;
    font-weight: 700;
    text-align: center;
    padding: 8px 4px;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.3s;
}

.back-button:hover {
  background-color: #2563eb;
}
  
.accessibiltiy-preview-empty{
    height: 100%;
    width: 80%;
    margin: auto;
    text-align: center;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    flex-direction: column;
    gap: 18px;
}

  .title-style{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  }
  .back-button{
  color: white
  }
  .section-card{
  display: flex;
  flex-direction: column;
    gap: 8px;

  justify-content: space-between;
  }
  .scrollable-section{
  max-height: 560px;
  overflow: hidden;
  overflow-y: auto;
     &::-webkit-scrollbar {
    display: none;
  }
  }
  .ant-card.ind-card{
  margin-top: 8px;
  border: 0.1px solid !important; 
  border-color: #a48383 !important;
  border-radius: 6px;
  color: white;
  background-color: inherit;
  }
  .ant-card.ind-card:hover{
  border: 2px solid !important;
  border-radius: 8px;
  border-color: #a48383 !important;
  }
.ant-card.img-card{
background-color: white;
border-radius: 12px;
}

  .icon-size{
  height: 28px;
  width: 28px;
  }
  .image-design{
    height: 70px;
  width: 70px;
  margin-right: 15px !important;
  border-radius: 50px;
  }
  .txt-color{
  color: white;
  max-height: 340px;
  overflow: hidden;
  overflow-y: auto !important;

    &::-webkit-scrollbar {
    display: none;
  }
  }
  .ant-tabs-nav {
    color: rgb(255 255 255 / 0.65) !important;
    font-weight: 600 !important;
    .ant-tabs-tab-active {
      color: #ffffff !important;
      font-weight: 700 !important;
    }
    .ant-tabs-tab {
      &:active {
        color: #ffffff !important;
      }
      &:hover {
        color: #ffffff !important;
      }
    }
  }
  .ant-tabs-ink-bar {
    background-color: #ffffff !important;
  }
  .ant-tabs-bar {
    border-bottom: #ffffff00 !important;
  }
  .ant-tabs-nav-wrap {
    text-align: center;
  }
`;

export const BorderedQuillContainer = styled.div`
  width: 100%;
  .ql-container.ql-snow {
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #ffffff;
    color: #000000;
    > .ql-editor {
      padding: 12px 15px;
    }
  }

  .text-block-toolbar > .ql-toolbar.ql-snow {
    .ql-custom-tray {
      > span {
        > button,
        > i {
          display: none !important;
        }
      }
    }
    #format-link,
    #formats-transform {
      display: none !important;
    }
    .ql-custom-tray {
      margin: auto;
    }
  }
`;
export const HtmlBlockContainer = styled.div`
  position: relative;
  z-index: ${props => props.currentBlock ? 2 : 0};
  // overflow: ${props => props.currentBlock ? 'visible': 'hidden'};
  overflow: ${props => props.staticTableBlock ? 'visible' : 'hidden'};
  padding: ${props => props.padding ? `${props.padding.top}px ${props.padding.right}px ${props.padding.bottom}px ${props.padding.left}px` : '0'};


  &.empty {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    // border-bottom: 1px dashed #00c4cc;
    color: #00c4cc;
    background: transparent;
    position: relative;
  }

  &.block-not-fit {
    border: dashed #FF0000;
  }

  .tag {
    background: #FF0000;
    color: #fff;
    font-size: 12px;
    min-width: 390px;
    width: fit-content;
    height: 25px;
    display: flex;
    align-items: center;
    font-weight: 600;
    position: absolute;
    z-index: 1;
    padding: 0 10px 0 10px;
    border-radius: 0 0 15px 0;
    top:0;
    left:0;
    svg {
      margin-left: 10px;
      font-size: 12px;
    }
  }

  svg {
    display: block;
  }

  .selectable {
    transform-origin: 0 0;
  }
`;

export const FillableElementWrapper = styled.div`
  position: relative;
  display: contents;
`;

export const ElementIndexHighlighter = styled.div`
  position: absolute;
  left: -35px;
  top: 10px;
  width: 35px;
  height: 30px;
  background: #00c4cc;
  color: white;
  opacity: 1;
  z-index: 0;
  font-size: 12px;
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
  transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out,
    -webkit-transform 0.25s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const tickSvg = () => (
  <svg width="20px" height="20px" viewBox="0 -3.5 170 170" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M142.196 30.4125C142.586 30.0637 142.897 29.6356 143.109 29.1567C143.32 28.6778 143.427 28.1592 143.422 27.6357C143.417 27.1122 143.3 26.5959 143.079 26.1213C142.858 25.6467 142.538 25.2248 142.141 24.8838C141.722 24.5249 141.307 24.1678 140.895 23.8127C137.751 21.1093 134.5 18.3102 131.1 15.9225C105.123 -2.36044 78.1316 -2.4633 50.8803 7.23287C26.2068 16.0055 10.3619 33.5563 3.77909 59.3882C-3.56415 88.249 2.86618 113.71 22.9048 135.073C23.4261 135.625 23.9582 136.177 24.4895 136.704C35.2539 147.469 48.6614 154.115 59.2847 158.739C63.8445 160.731 87.2404 163.149 93.5707 162.206C131.19 156.588 155.946 135.37 164.569 99.8725C166.215 92.9194 167.035 85.7962 167.011 78.6508C166.974 71.1466 165.712 63.6988 163.275 56.6012C163.097 56.0703 162.805 55.5851 162.418 55.1805C162.031 54.7759 161.56 54.4618 161.037 54.2606C160.515 54.0595 159.954 53.9764 159.396 54.0171C158.838 54.0579 158.295 54.2216 157.808 54.4965L157.706 54.5547C156.931 54.9984 156.336 55.7005 156.027 56.5381C155.717 57.3757 155.712 58.2954 156.012 59.1364C158.212 65.2371 159.334 71.674 159.327 78.1592C159.251 85.9394 158.198 93.6792 156.192 101.197C150.248 122.8 136.038 138.545 112.75 149.315C89.0741 160.65 55.1215 149.19 46.0879 143.226C36.1031 136.4 27.3663 127.908 20.2596 118.121C9.11418 102.34 6.61369 79.6587 12.6028 58.9229C15.4055 49.3489 20.3036 40.5185 26.9421 33.0722C33.5806 25.6259 41.793 19.7503 50.9838 15.8714C74.8941 5.93474 98.8852 4.18192 122.285 19.0635C125.422 21.061 133.422 27.3424 137.465 30.5501C138.143 31.0882 138.99 31.3691 139.855 31.3432C140.721 31.3172 141.549 30.986 142.194 30.4082L142.196 30.4125Z" fill="#75d6c7" />
    <path d="M142.196 30.4125C142.586 30.0637 142.897 29.6356 143.109 29.1567C143.32 28.6778 143.427 28.1592 143.422 27.6357C143.417 27.1122 143.3 26.5959 143.079 26.1213C142.858 25.6467 142.538 25.2248 142.141 24.8838C141.722 24.5249 141.307 24.1678 140.895 23.8127C137.751 21.1093 134.5 18.3102 131.1 15.9225C105.123 -2.36044 78.1316 -2.4633 50.8803 7.23287C26.2068 16.0055 10.3619 33.5563 3.77909 59.3882C-3.56415 88.249 2.86618 113.71 22.9048 135.073C23.4261 135.625 23.9582 136.177 24.4895 136.704C35.2539 147.469 48.6614 154.115 59.2847 158.739C63.8445 160.731 87.2404 163.149 93.5707 162.206C131.19 156.588 155.946 135.37 164.569 99.8725C166.215 92.9194 167.035 85.7962 167.011 78.6508C166.974 71.1466 165.712 63.6988 163.275 56.6012C163.097 56.0703 162.805 55.5851 162.418 55.1805C162.031 54.7759 161.56 54.4618 161.037 54.2606C160.515 54.0595 159.954 53.9764 159.396 54.0171C158.838 54.0579 158.295 54.2216 157.808 54.4965L157.706 54.5547C156.931 54.9984 156.336 55.7005 156.027 56.5381C155.717 57.3757 155.712 58.2954 156.012 59.1364C158.212 65.2371 159.334 71.674 159.327 78.1592C159.251 85.9394 158.198 93.6792 156.192 101.197C150.248 122.8 136.038 138.545 112.75 149.315C89.0741 160.65 55.1215 149.19 46.0879 143.226C36.1031 136.4 27.3663 127.908 20.2596 118.121C9.11418 102.34 6.61369 79.6587 12.6028 58.9229C15.4055 49.3489 20.3036 40.5185 26.9421 33.0722C33.5806 25.6259 41.793 19.7503 50.9838 15.8714C74.8941 5.93474 98.8852 4.18192 122.285 19.0635C125.422 21.061 133.422 27.3424 137.465 30.5501C138.143 31.0882 138.99 31.3691 139.855 31.3432C140.721 31.3172 141.549 30.986 142.194 30.4082L142.196 30.4125Z" fill="#a8e6dc" />
    <path d="M74.6287 104.313C76.2312 102.79 77.1115 102.019 77.9173 101.177C103.753 74.1855 132.047 49.8851 160.508 25.7727C161.584 24.8619 162.685 23.7 163.958 23.3737C165.493 22.9815 167.996 23.4326 168.682 24.2661C169.133 24.8821 169.418 25.6035 169.509 26.3612C169.601 27.1189 169.496 27.8875 169.206 28.5932C168.537 30.3474 166.907 31.8498 165.429 33.1629C156.607 41.0019 147.538 48.5708 138.872 56.5716C120.756 73.3024 102.756 90.1576 84.8704 107.137C77.0334 114.561 74.0173 114.862 66.8059 106.929C62.0589 101.705 47.7328 84.0973 43.3455 78.5495C42.7256 77.6872 42.1735 76.7781 41.6941 75.8305C40.7045 74.0756 40.0576 72.1419 42.0246 70.7814C44.2158 69.2662 45.7707 70.8473 47.0696 72.4937C48.384 74.1607 49.5048 75.9916 50.9121 77.5713C55.2811 82.4737 69.908 99.1421 74.6287 104.313Z" fill="#75d6c7" />
    <path d="M74.6287 104.313C76.2312 102.79 77.1115 102.019 77.9173 101.177C103.753 74.1855 132.047 49.8851 160.508 25.7727C161.584 24.8619 162.685 23.7 163.958 23.3737C165.493 22.9815 167.996 23.4326 168.682 24.2661C169.133 24.8821 169.418 25.6035 169.509 26.3612C169.601 27.1189 169.496 27.8875 169.206 28.5932C168.537 30.3474 166.907 31.8498 165.429 33.1629C156.607 41.0019 147.538 48.5708 138.872 56.5716C120.756 73.3024 102.756 90.1576 84.8704 107.137C77.0334 114.561 74.0173 114.862 66.8059 106.929C62.0589 101.705 47.7328 84.0973 43.3455 78.5495C42.7256 77.6872 42.1735 76.7781 41.6941 75.8305C40.7045 74.0756 40.0576 72.1419 42.0246 70.7814C44.2158 69.2662 45.7707 70.8473 47.0696 72.4937C48.384 74.1607 49.5048 75.9916 50.9121 77.5713C55.2811 82.4737 69.908 99.1421 74.6287 104.313Z" fill="#a8e6dc" />
  </svg>
);

export const tickSvg1 = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10" fill="#22C55E" />
    <path
      d="M7 12L10 15L17 8"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export const percentageSvg = (percentage) => (
  <svg width="80%" height="100%" viewBox="0 0 42 42" className="donut">
    <circle cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke={percentage >= 80 ? '#a8e6dc' : percentage >= 50 && percentage < 80 ? '#FFD999' : percentage < 50 && percentage >= 25 ? "#f29d7f" : '#d95d5d'} strokeWidth="5" />
    <circle cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke={percentage >= 80 ? '#2a9d8f' : percentage >= 50 && percentage < 80 ? '#FFA000' : percentage < 50 && percentage >= 25 ? "#E25822" : '#a82828'} strokeWidth="5" strokeDasharray="100, 100" strokeDashoffset={100 - percentage} strokeLinecap="round" transform="rotate(-90 21 21)" />
    <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" fontSize="6" fill="#ffff"> {percentage}% </text>
  </svg>
);
export const AccessibilitySeparator = styled.div`
  position: relative;
  border-bottom: ${({accessibleType}) => ['dynamicTable', 'staticTable'].includes(accessibleType) ? 'none': '2px solid #5DE1E6'};
  
  .accessible-tag {
    position: absolute;
    right:0; 
    bottom: 0; 
    background-color:#D5DEE5;
    padding:2px 5px; 
    border-top-left-radius:10px;
    text-transform: capitalize; 
    display:flex; 
    align-items:center;
    opacity: ${({accessibleType}) => ['dynamicTable', 'staticTable'].includes(accessibleType) ? '0.2': '1'};

      span {
      width :20px;
      height :20px;
      }
  }
  .accessible-tag:hover { 
    opacity: ${({accessibleType}) => ['dynamicTable', 'staticTable'].includes(accessibleType) ? '1': '1'};
  }
`
export const Overlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  position: absolute;
  top: 0;
  left: 74px;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(4px);
   background: rgba(2, 2, 2, 0.82);
  backdrop-filter: blur(10px);
  pointer-events: all; /* Disables interaction with underlying elements */
  z-index: 101;
`;

export const OverlayText = styled.div`
  color: #ffffff;
  font-weight: bold;
  text-align: center;
  padding: 0 15px;
  height: 100%;
  display: flex;
  align-items: center;

`;